// « Les signes de l'équipe » (D-161, choix 6 ; maquette d4 de D-162) : à côté de chaque geste dessiné par Arceau, son
// sens pour l'équipe (« Corne → Horns 4 »). La base fait le tri (table team_signs) : le staff de l'équipe lit et écrit,
// ses joueuses et joueurs (en personne) lisent, les parents, les autres équipes et l'anonyme ne voient rien.
import { supabase } from './supabase';
import type { SignId } from '../domain/signs';

export interface TeamSign { sign: SignId; meaning: string; detail: string | null; updated_at: string }

const db = () => {
  if (!supabase) throw new Error('Base non configurée');
  return supabase;
};

/** Les signes qui ont un sens pour l'équipe (vide si l'on n'a pas le droit de les lire). */
export async function teamSigns(teamId: string): Promise<TeamSign[]> {
  const { data, error } = await db().from('team_signs').select('sign, meaning, detail, updated_at').eq('team_id', teamId);
  if (error) throw new Error(error.message);
  return (data ?? []) as TeamSign[];
}
/** geste → sens, pour les drills (« le nom du système après 1 s »). */
export const teamSignNames = async (teamId: string | null | undefined): Promise<Map<string, string>> =>
  teamId ? new Map((await teamSigns(teamId).catch(() => [] as TeamSign[])).map(s => [s.sign, s.meaning])) : new Map();

/** Donne (ou change) le sens d'un geste ; un sens vide le retire. */
export async function setTeamSign(teamId: string, sign: SignId, meaning: string, detail: string): Promise<void> {
  const m = meaning.trim().slice(0, 60), d = detail.trim().slice(0, 120);
  const q = m
    ? db().from('team_signs').upsert({ team_id: teamId, sign, meaning: m, detail: d || null }, { onConflict: 'team_id,sign' })
    : db().from('team_signs').delete().eq('team_id', teamId).eq('sign', sign);
  const { error } = await q;
  if (error) throw new Error(error.message);
}
